const adminReseller = {
  resellerProgram: 'Программа реселлеров',
  customersComeFrom: 'Клиенты поступают из:',
  suppliers: 'Поставщики:',
  installsSoldMonthly: 'Количество проданных установок ежемесячно:',
  channels: 'Каналы:',
  services: 'Услуги:',
};

export default adminReseller;
